import AppLogo from '../../atoms/images/modalLogo';
import Container from '../../atoms/container/modalContainer';
import Buttons from '../../elements/modal/anonymousModalButtons';
import Description from '../../elements/modal/anonymousModalDescription';
import FlavourConfig from '../../../../shared/config/flavours';
import Icons from '../../elements/modal/anonymousModalUpgrades';
import Literals from '../../../../shared/assets/locale/default/es.json'; // TODO: Language selector
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import useCloseModalKeyboard from '../../../../shared/components/utils/hooks/useCloseModalKeyboard';

function AnonymousGenericModal() {
  useCloseModalKeyboard();
  return (
    <>
      <Container>
        <AppLogo />
        <Description />
        <Title>
          {TranslationManager.get(
            'MODAL.ANONYMOUS.TITLE',
            FlavourConfig.appTitle
          )}
        </Title>
        <Subtitle>{Literals.MODAL.ANONYMOUS.SUBTITLE}</Subtitle>
        <Icons />
        <Buttons />
      </Container>
    </>
  );
}

export default AnonymousGenericModal;
